module.exports = __webpack_public_path__ + "img/credit-cards-payment.cee1ceb9.svg";